import { colors } from '../../../shared/styles/baseStyle';

export const policyNumberItem = { marginTop: 15 };
export const inputItem = { borderRadius: 8 };
export const termsItem = { marginTop: -15 };
export const checkBoxText = { fontSize: 11, fontWeight: 'bold' };
export const linkColor = { color: colors.anytimeBlue };
export const buttonItem = { marginTop: 60, marginBottom: 20 };
export const button = {
  color: 'white',
  border: 'none',
  borderRadius: 8,
  fontWeight: 600
};
